var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSultanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 16",
    enableBackground: "new 0 0 44 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M10 0h24v7H10zM0 0h9v7H0zM35 0h9v7h-9zM10 9h24v7H10zM0 9h9v7H0zM35 9h9v7h-9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSultanIcon);
export default __webpack_public_path__ + "static/media/sultan_icon.ed9de1907d8bf8d06588fd9cab3af30c.svg";
export { ForwardRef as ReactComponent };